<template>
    <div class="addInfo">
    		<h2 style="text-align: center;color: #45aaf9;font-size: 24px;height: 80px;line-height: 50px;padding-top: 30px;">修改信息</h2>
				<Row>
          <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
          <Row class="firstRow">
            <Col class="leftName" span="2" offset="1">
              信息标题
            </Col>
            <Col span="19" offset="1">
              <FormItem style="width:50%;" class="longType" prop="title">
                <Input type="text" v-model="formInline.title" placeholder="请输入信息标题">
                </Input>
              </FormItem>
            </Col>
          </Row>
					<Row class="secondRow">
            <Col class="leftName" span="2" offset="1">
              插&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;入
            </Col>
            <Col span="19" offset="1">
						  <Button :type="typeStr1" @click="showP">图片</Button>
						  <Button :type="typeStr2" @click="showV">视频</Button>
            </Col>
          </Row>
					<Row class="thirdRow" v-show="showPict">
						<Col span="19" offset="4">
              <FormItem class="secondType" style="width: 100%" prop="picture">
              <div class="demo-upload-list" v-for="(item,index) in uploadArr" :key="index">
        <template v-if="item.status === 'finished'">
            <img :src="addQian(item)">
            <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item,index)"></Icon>
            </div>
        </template>
        <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
    </div>
    <Upload
    	class="isImgKuang"
        ref="upload"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :format="['jpg','jpeg','png','gif']"
        :max-size="2048"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        multiple
        type="drag"
        :action=this.action
		:headers=this.headers
        style="display: inline-block;width:208px;">
        <div style="width: 208px;height:134px;line-height: 134px;">
            <Icon type="camera" size="20"></Icon>
        </div>
    </Upload>
    <Modal title="预览" v-model="visible">
        <img :src="addQian2(imgName)" style="width: 100%">
    </Modal>
            </FormItem>
            </Col>
					</Row>
					<Row class="thirdRow" v-show="!showPict">
						<Col span="19" offset="4">
              <FormItem class="secondType" style="width: 100%" prop="picture2">
              <div class="demo-upload-list" v-for="(item,index) in uploadArrV">
                  <template v-if="item.status === 'finished'">
                      <video style="height: 100%;width: 100%;" :src="addQian(item)"></video>
                      <div class="demo-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleViewV(item)"></Icon>
                          <Icon type="ios-trash-outline" @click.native="handleRemoveV(item,index)"></Icon>
                      </div>
                  </template>
                  <template v-if="item.status !== 'finished'">
                      <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                  </template>
              </div>
							<Upload
									class="isImgKuang isVideoKuang"
									ref="uploadV"
									:show-upload-list="false"
									:on-success="handleSuccessV"
                  :default-file-list="defaultListV"
									:format="['mp4','avi','mkv']"
									:max-size="204800"
									:on-format-error="handleFormatErrorV"
									:on-exceeded-size="handleMaxSizeV"
									:before-upload="handleBeforeUploadV"
									multiple
									type="drag"
									:action=this.action
									:headers=this.headers
									style="display: inline-block;width:208px;">
									<div style="width: 208px;height:134px;line-height: 134px;">
											<Icon type="ios-videocam" size="20"></Icon>
									</div>
							</Upload>
							<Modal title="视频" v-model="visibleV">
								<video style="width: 100%;" controls="" autoplay="" name="media"><source :src="addQian2(videoName)" v-if="visibleV" type="video/mp4"></video>
							</Modal>
            </FormItem>
            </Col>
					</Row>
          <Row class="eightRow">
            <Col class="leftName" span="2" offset="1">
              消息正文
            </Col>
            <Col span="19" offset="1">
              <quill-editor style="height: 200px;" id="editor"
              v-model="content" 
              ref="myQuillEditor" 
              @focus="onEditorFocus($event)"
              :options="editorOption"
              @change="onEditorChange($event)">
              </quill-editor>
            </Col>
          </Row>
          <Row class="fouthRow">
            <Col span="19" offset="4">
              <FormItem label="">
                  <Checkbox  v-model="formInline.type">活动报名</Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row class="fiveRow" v-show="formInline.type">
            <Col span="19" offset="4">
              <Form-item style="width: 100%;" label="接收人：">
                选择参加人员:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button style="margin-left: ;" type="primary" @click="selectPeopleShow = true">添加成员</Button>                
                <div class="acceptPerson textArea" >
                    <div class="person_box" >
                        <ul class="inBox">
                            <li class="per_item" v-for="item in acceptPersons" @click="selectionDelete" :data-item = JSON.stringify(item)>
                                <span class="close"><Icon type="ios-close" size="14" color="#444444"/></span>
                                <span>{{item.receive_departments}}</span>&nbsp;&nbsp;<span>{{item.receive_roles}}</span>&nbsp;&nbsp;<span>{{item.receive_users}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
              </Form-item>
            </Col>
          </Row>
          <Row class="sixRow" v-show="formInline.type">
            <Col span="19" offset="4">
              活动截止时间:&nbsp;&nbsp;&nbsp;&nbsp;<DatePicker v-model="deadline" type="datetime" placeholder="请选择活动时间" style="width: 200px"></DatePicker>
            </Col>
          </Row>
          <department-RolePerson v-model="selectPeopleShow" :existPeoples="personList"  @on-ok="handleSelectPerson" ></department-RolePerson>
        </Form>
        </Row>
        <Row class="nineRow">
          <Button @click="send" type="primary">修改</Button>
        </Row>
    </div>
</template>

<script>
import departmentRolePerson3 from "./departmentRolePerson3";
import "assets/../global/setting";
import "assets/../global/jq";
import { quillEditor } from "vue-quill-editor";
export default {
  props:["infoId"],
  components: {
    'department-RolePerson':departmentRolePerson3
  },
  data() {
    return {
      content: null,
      typeStr1: "primary",
      typeStr2: "",
      editorOption: {
        placeholder: "请输入正文"
      },
      editor: {},
      defaultList: [],
      imgName: "",
      _id:"",
      headers: { token: window.localStorage.getItem("token") },
      action: parameters.domain + "/manage/messagelist/upload",
      visible: false,
      uploadList: [],
      showPict: true,
      uploadArr: [],
      defaultListV: [],
      formInline: {
        title: "",
        type: false
      },
      ruleInline: {
        title: [
          {
            required: true,
            message: "请输入信息标题",
            trigger: "blur"
          }
        ]
      },
      deadline:"",
      //视频的配置
      uploadArrV: [],
      visibleV: false,
      //选择人员
      selectPeopleShow:false,
      acceptPersons:[],
    };
  },
  computed:{
    //已选人员数据传回组建里
    personList:function () {
        let list = [];
        this.acceptPersons.map((item) =>{
            let obj = {department:item.receive_departments,role:item.receive_roles,username:item.receive_users};
            list.push(obj)
            console.log(item);
        });
        return list;
    },
  },
  methods: {
    //获得数据
    getData(){
        var that = this;
        var params = {};
        params.url = '/manage/messagelist/list'
        params.data ={
            searchValue:{
                "id":this.infoId
            }
        };
        params.system_id = 5000000;
        params.token = window.localStorage.getItem("token");
        params.success = function (res) {
            res = res.data.result.result[0];
            console.log("res is",res);
            that.formInline.title = res.title;
            that.defaultList = res.image;
            that.defaultListV = res.video;
            that._id =  res._id;
            that.content = res.content;
            if(res.type == "activity"){
              that.formInline.type = true;
              that.acceptPersons = res.receive;
              var nian = res.deadline.split(" ")[0].split("-")[0];
              var yue = res.deadline.split(" ")[0].split("-")[1]-1;
              var ri = res.deadline.split(" ")[0].split("-")[2];
              var shi = res.deadline.split(" ")[1].split(":")[0];
              var fen = res.deadline.split(" ")[1].split(":")[1];
              var miao = res.deadline.split(" ")[1].split(":")[2];    
              that.deadline = new Date(nian,yue,ri,shi,fen,miao);       
            }else{
              that.formInline.type = false;
            }
            setTimeout(() => {
                that.uploadArr = that.$refs.upload.fileList;
                that.uploadArrV = that.$refs.uploadV.fileList;
                for(var i=0;i<that.uploadArr.length;i++){
                	that.uploadArr[i].url = parameters.domain+that.uploadArr[i].url
                }
                for(var i=0;i<that.uploadArrV.length;i++){
                	that.uploadArrV[i].url = parameters.domain+that.uploadArrV[i].url
                }
                if(that.uploadArrV.length>0){
                	that.showV()
                }
            }, 50);
        };
        this.ajaxPost(params);
    },
    addQian2(path){
    	var ele = path.split(parameters.domain).length - 1;
    	return parameters.domain+path.split(parameters.domain)[ele];
    },
    addQian(path) {
    	if(path.url){
    		var ele = path.url.split(parameters.domain).length - 1;
    		return parameters.domain+path.url.split(parameters.domain)[ele];
    	}else{
    		return parameters.domain+path.response.result.path;
    	}
//    if(path.url){
//    	var n = (path.url.split('https://fsswj.com/wtshuiwen')).length-1;
//    	if(n==2){
		
//    	}else{
//      	return path.url;
//    	}
//    }else{
//      return parameters.domain+path.response.result.path;
//    }
      //return parameters.domain+path;
    },
    //发送表单
    send(num) {
      var that = this;
      var arrP = [];
      var arrV = [];
      var zhuangtai = "";
      var time = this.deadline.format('yyyy-MM-dd hh:mm:ss');
      if(!this.formInline.type){
        zhuangtai = "simple";
      }else{
        zhuangtai = "activity";
      }
      var that = this;
      var params = {};
      
      for(var i=0;i<this.uploadArr.length;i++){
        var obj = {};
        if(this.uploadArr[i].url){
          obj.url = this.uploadArr[i].url;
          obj.name = this.uploadArr[i].name;
        }else{
          obj.name = this.uploadArr[i].response.result.filename;
          obj.url = this.uploadArr[i].response.result.path;
        }
        arrP.push(obj);
      }
      for(var i=0;i<this.uploadArrV.length;i++){
        var obj = {};
        if(this.uploadArrV[i].url){
          obj.url = this.uploadArrV[i].url;
          obj.name = this.uploadArrV[i].name;
        }else{
          obj.name = this.uploadArrV[i].response.result.filename;
          obj.url = this.uploadArrV[i].response.result.path;
        }
        arrV.push(obj);
      }
      params.url = '/manage/messagelist/edit'
      params.data ={};
      params.data.id = this.infoId;
      params.data._id = this._id;
      params.data.type = zhuangtai;
      params.data.title = this.formInline.title;
      params.data.image = arrP;
      params.data.video = arrV;
      params.data.content = this.content;
      if(this.formInline.type){
        params.data.receive = this.acceptPersons;
        params.data.deadline = time;
      }
      params.data.status = false;
      params.token = window.localStorage.getItem("token");
      params.success = function (res) {
        res = res.data;
        that.$Message.success(res.message);
        that.$router.push("/data/infoList");
      };
      console.log(params.data);
      this.ajaxPost(params);
    },
    onEditorFocus() {
      //this.editor.quill.insertEmbed(10, 'video', 'https://v.qq.com/iframe/player.html?vid=z0020jq459e&tiny=0&auto=0');
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
    },
    showP() {
      if(this.uploadArrV.length>0){
      	  this.$Notice.warning({
	        title: "请删除视频后再上传图片",
	      });
      }else{
      	  this.showPict = true;
	      this.typeStr1 = "primary";
	      this.typeStr2 = "";
      }
    },
    showV() {
    	if(this.uploadArr.length>0){
      	  this.$Notice.warning({
	        title: "请删除图片后再上传视频",
	      });
        }else{
      	  this.showPict = false;
      	  this.typeStr2 = "primary";
      	  this.typeStr1 = "";
        }
    },
    handleView(url) {
    	if(url.url){
      		url = url.url;
    	}else{
    		url = parameters.domain+url.response.result.path
    	}

      this.imgName = url;
      this.visible = true;
    },
    handleRemove(item,index) {
      if(item.url){
        var path = item.url;
      }else{
        var path = item.response.result.path;
      }
      var ele = document.getElementsByClassName("ql-editor")[0].childNodes;
      var arr = [];
      for (var i = 0; i < $(ele).find("img").length; i++) {
        arr.unshift($(ele).find("img")[i]);
      }
      for (var i = 0; i < arr.length; i++) {
        if ($(arr[i]).attr("src") == path) {
          //arr[i].parentNode.removeChild(arr[i]);
          break;
        }
      }
      this.uploadArr.splice(index, 1);
    },
    handleSuccess(res, file) {
      var that = this;
      var str = res.result.path;
      //this.editor.quill.insertEmbed(1, "image",str );
      this.$Message.success("上传成功");
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "图片格式不正确",
        desc: "只能是png或者jgp或者gif或者jepg格式"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片过大",
        desc: file.name + " 太大，不能超过2M"
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 5;
      if (!check) {
        this.$Notice.warning({
          title: "一次最多只能上传五张图片"
        });
      }
      return check;
    },
    //视频的方法
    handleViewV(url) {
    	console.log(url,"dkslajdlas");
      if(url.url){
      		url.url.split(parameters.domain);
      		console.log(url.url);
      		
      		url = parameters.domain+url.url.split(parameters.domain)[url.url.split(parameters.domain).length-1];
    	}else{
    		url = parameters.domain+url.response.result.path;
    	}
      this.videoName = url;
      this.visibleV = true;
    },
    handleRemoveV(item,index) {
      if(item.url){
        var path = item.url;
      }else{
        var path = item.response.result.path;
      }
      var arr = [];
      for (var i = 0; i < $(".ql-editor").find("iframe").length; i++) {
        arr.unshift($(".ql-editor").find("iframe")[i]);
      }
      for (var i = 0; i < arr.length; i++) {
        console.log($(arr[i]).attr("src"),"   adn   ",path)
        if ($(arr[i]).attr("src") == path) {
          //arr[i].parentNode.removeChild(arr[i]);
          break;
        }
      }
      this.uploadArrV.splice(index, 1);
    },
    handleSuccessV(res, file) {
      var that = this;
      var str = res.result.path;
      //this.editor.quill.insertEmbed(1, "video", str);
      this.$Message.success("上传成功");
    },
    handleFormatErrorV(file) {
      this.$Notice.warning({
        title: "视频格式不正确",
        desc: "只能是mp4、avi、mkv格式"
      });
    },
    handleMaxSizeV(file) {
      this.$Notice.warning({
        title: "视频过大",
        desc: file.name + " 太大，不能超过200M"
      });
    },
    handleBeforeUploadV() {
    	console.log(this.uploadArrV.length);
      const check = this.uploadArrV.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: "一次最多只能上传一个视频"
        });
      }
      return check;
    },
    //选择人员方法
    //组建里选人数据传到页面去
    handleSelectPerson(data){
        console.log(data);
        var that=this;
        this.acceptPersons=[];
        for(var i=0;i<data.length;i++){
            let obj = {receive_departments:data[i].department,receive_roles:data[i].role,receive_users:data[i].username};
            that.acceptPersons.push(obj);
        }
    },
    //设置功能的title
    setTitle(){
    	
    },
    //获取部门信息
            getDepartments(){
                var that = this;
                var params = {};
                params.url = '/sys/department/list'
                params.data ={};
                params.system_id = 5000000;
                params.token = window.localStorage.getItem("token");
                params.success = function (res) {
                  res = res.data;
                    if(res.code = '0000'){
                        that.departments = res.result.result;
                    }
                };
                params.error = function (res) {console.error(res)};
                this.ajaxPost(params)
            },
            //根据部门获取角色信息
            getRoles(dep) {
                var that = this;
                this.roles = [];
                var params = {};
                params.url = '/sys/role/list';
                params.token = window.localStorage.getItem("token");
                params.data ={'searchValue':{'department.name':dep,'flag':0}};
                params.success = function (res) {
                  res = res.data;
                    if(res.code = '0000'){
                        var data = res.result.result;
                        data.map((item) =>{
                            var obj = {};
                        obj.value = item.rolename;
                        obj.label = item.rolename;
                        that.roles.push(obj);
                    })

                    }
                };
                this.ajaxPost(params)
            },
            //根据部门、角色获取人员
            getPeople:function (dep,role) {
                var that = this;
                this.persons = [];
                var params = {};
                params.url = '/sys/userinfo/list';
                params.token = window.localStorage.getItem("token");
                params.data ={'searchValue':{'roles.rolename':role,'flag':0}};
                params.success = function (res) {
                  res = res.data;
                    if(res.code = '0000'){
                        var data = res.result.result;
                        if(res.result.result.length==0){
                            var obj={
                                userid:'暂无人员',
                                realname:'暂无人员'
                            }
                            that.persons.push(obj)
                            that.no_person=true
                        }else{
                            data.map((item) =>{
                                that.persons.push(item);
                            })
                            that.no_person=false
                        }

                    }
                };
                this.ajaxPost(params)
            },
            //下拉框change事件处理
            selectChange(type,value){
                switch (type){
                    case 'department':
                        this.getRoles(value)
                        break;
                    case'role':
                        this.getPeople(this.ace_person.department,value)
                        break;
                    case'form_item_group':
                        this.getForm_Items(value);
                }
            },
            //确定选择处理人
            personCommit:function(){
                if(this.department =="" && this.role =="" && this.person == ""){
                    return;
                };
                var a_dep = '';
                var a_role = '';
                var a_username = '';
                for(let i in this.acceptPersons){
                    a_dep = this.acceptPersons[i].receive_departments;
                    a_role = this.acceptPersons[i].receive_roles;
                    a_username = this.acceptPersons[i].receive_users;
                    if(a_dep != '' && a_role == '' && a_username ==''){//已选择处理人中存在选中谋部门所有人时，新添加的处理人属于这个部门时，不让新添加该处理人
                        if(this.ace_person.department == a_dep){
                            return;
                        }
                    }else if(a_dep != '' && a_role != '' && a_username ==''){//已选择处理人中存在选中谋部门下某角色的所有人时，新添加的处理人属于这个部门下的这个角色时，不让新添加该处理人
                        if(this.ace_person.department == a_dep && this.ace_person.role == a_role){
                            return;
                        }
                    }else {//已选择处理人中存在和新添加的处理热相同时，不让新添加该处理人
                        if(this.ace_person.department == a_dep && this.ace_person.role == a_role  && this.ace_person.person == a_username){
                            return;
                        };
                    }
                }
                if(this.ace_person.department==''){
                    this.$Notice.warning({
                        title: '请选择接收人'
                    });
                }else{
                    var per = {};
                    per.receive_departments = this.ace_person.department;
                    per.receive_roles = this.ace_person.role;
                    per.receive_users = this.ace_person.person;
                    this.receiverList=this.ace_person.person
                    this.acceptPersons.push(per);
                }

//                console.log(this.formInline.acceptPersons)
            },
            //删除选中人
            selectionDelete () {
                var that = this;
                setTimeout(function () {
                    $(".person_box").delegate(".per_item","click",function (ev) {
                        $(".person_box .close").css("display","none");
                        $($(this).children('span')[0]).show();//选中时显示删除图标
                        that.selectedPerson = JSON.parse($(this).attr("data-item"));
                    });

                    //点击删除图标时删除选中人
                    $(".person_box").delegate('.per_item .close',"click",function (ev) {
                        var dataItem = JSON.parse($(this).parent().attr("data-item"));
                        var delIndex = "";
                        that.acceptPersons.map((item,index) => {
                            if(item.receive_departments == dataItem.receive_departments && item.receive_roles == dataItem.receive_roles && item.receive_users == dataItem.receive_users){
                            delIndex = index;
                            that.acceptPersons.splice(delIndex,1)
                        }
                    })

                    })
                },50)
            }
  },
  mounted() {
  	this.setTitle()
    this.getData();
    var data = new Date();
    this.deadline = data;
    this.editor = this.$refs.myQuillEditor;
    this.getDepartments();
  }
};
</script>

<style lang="scss">
	.addInfo{
		.ql-snow .ql-tooltip[data-mode=video]::before{
			content: "视频链接";
		}
		.ql-snow .ql-tooltip[data-mode=link]::before{
			content: "跳转链接";
		}
		.ql-snow .ql-tooltip a.ql-action::after{
			content: "确认";
		}
		.ql-toolbar{
			position: absolute;
			top: 0;
			border: 0;
			height: 50px;
			top: -50px;
		}
		.eightRow{
			margin-top: 50px;
		}
		.ql-editor{
			border-top: 1px solid rgb(204,204,204);
		}
		.ql-blank{
			font-size: 14px;
			color: #706767;
			font-style: initial;
		}
		.fiveRow{
			button{
				text-align: right;
				width: 90px;
				background-color: transparent;
				border: 0;
				color: #706767;
				background: url(../../assets/infoMana/addIcon.png) left center no-repeat;
			}
		}
		.sixRow{
			.ivu-input-icon-normal+.ivu-input{
				padding-right: 7px;
				text-align: center;
				font-size: 14px;
				color: #706767;
			}
			.ivu-input-icon{
				display: none;
			}
		}
		.nineRow{
			button{
				font-size: 16px;
				width: 120px;
				height: 30px;
				line-height: 20px;
			}
		}
	}
	.isImgKuang{
		.ivu-icon{
			width: 46px;
			height: 46px;
			left: 50%;
			top: 25%;
			position: absolute;
			margin-left: -23px;
		}
		.ivu-icon:before{
			content: "";
			display: block;
			height: 100%;
			width: 100%;
			background: url(../../assets/infoMana/carmericon.png) no-repeat center center;
		}
		.ivu-icon:after{
			content: "添加照片";
			font-size: 14px;
			width: 100%;
			display: inline-block;
			color: #414141;
			width: 50px;
		    position: absolute;
		    width: 70px;
		    left: -10px;
			text-align: center;
		}
	}
	.isVideoKuang{
		.ivu-icon:before{
			background: url(../../assets/infoMana/videoIcon.png) no-repeat center center;
		}
		.ivu-icon:after{
			content: "添加视频";
		}
	}
.leftName{
  line-height: 32px;
}
.firstRow{
  margin-top: 20px;
  height: 60px;
  .ivu-form-inline .ivu-form-item{
    width: 100%;
  }
}
.secondRow{
  button{
    width: 100px;
    height: 30px;
  }
  button:first-child{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  button:nth-child(2){
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -3px;
  }
}
.thirdRow{
  margin-top: 20px;
  .demo-upload-list{
    width: 208px;
    line-height: 134px;
    height: 134px;
    img{
      object-fit: contain;
    }
  }
}
.fouthRow{
  font-size: 24px;
  .ivu-checkbox-wrapper{
    font-size: 18px;
  }
  .ivu-checkbox-inner{
    width: 18px;
    height: 18px;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner:after{
    top: 3px;
    left: 6px;
  }
  .ivu-form-inline .ivu-form-item{
    width: 100%;
  }
}
.fiveRow{
  .inBox{
    width: 100%;
    height: 150px;
    border: 1px solid #d1d1d1;
    border-radius: 5px;
    margin-top: 15px;
    padding: 10px;
    li{
      float: left;
      background: #d1d1d1;
      border-radius: 5px;
      padding-left: 3px;
      margin: 2px;
      .close{
        float: right;
        margin-right: 3px
      }
    }
  }
}
.eightRow{
  height: 288px;
}
.nineRow{
  text-align: center;
  button{
    width: 150px;
    margin: 25px;
  }
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.ql-formats .ql-video{
  display: none !important;
}
.ql-formats>*{
	position:relative;
}
.ql-formats>*:hover::before{
    content: "\52A0\7C97";
    position: absolute;
    top: -33px;
    left: 50%;
    width: 70px;
    padding: 2px 6px;
    display: inline-block;
    color: #333;
    border: 1px solid #333;
    border-radius: 5px;
    font-size: 14px;
    margin-left: -35px;
}

.ql-formats>*:hover::after{
    content: "";
    border-top: 5px solid #333;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    position: absolute;
    top: -6px;
    left: 50%;
    margin-left: -6px;
}
.ql-formats .ql-italic:hover::before{
	content: "斜体";
}
.ql-formats .ql-underline:hover::before{
	content: "下划线";
}
.ql-formats .ql-strike:hover::before{
	content: "删除线";
}
.ql-formats .ql-blockquote:hover::before{
	content: "引用";
}
.ql-formats .ql-code-block:hover::before{
	content: "块状";
}
.ql-formats .ql-header:hover::before{
	content: "大标题";
}
.ql-formats .ql-header:nth-child(2):hover::before{
	content: "小标题";
}
.ql-formats .ql-list:nth-child(1):hover::before{
	content: "有序列表";
}
.ql-formats .ql-list:nth-child(2):hover::before{
	content: "无序列表";
}
.ql-formats .ql-script:nth-child(2):hover::before{
	content: "上标";
}
.ql-formats .ql-script:nth-child(1):hover::before{
	content: "下标";
}
.ql-formats .ql-indent:nth-child(1):hover::before{
	content: "段落左移";
}
.ql-formats .ql-indent:nth-child(2):hover::before{
	content: "段落右移";
}
.ql-formats .ql-direction:hover::before{
	content: "左对齐";
}
.ql-formats .ql-size:hover::before{
	content: "字体大小";
}
.ql-formats .ql-header:hover::before{
	content: "段落标题大小";
	width: 100px;
	margin-left: -50px;
}
.ql-formats .ql-color:hover::before{
	content: "字体颜色";
}
.ql-formats .ql-background:hover::before{
	content: "字体背景颜色";
	width: 100px;
	margin-left: -50px;
}
.ql-formats .ql-font:hover::before{
	content: "字体格式";
}
.ql-formats .ql-align:hover::before{
	content: "段落位置";
}
.ql-formats .ql-clean:hover::before{
	content: "清除格式";
}
.ql-formats .ql-link:hover::before{
	content: "添加超链接";
	width: 100px;
	margin-left: -50px;
}
.ql-snow .ql-picker.ql-header{
	width: 130px;
}
.ql-formats .ql-image:hover::before{
	content: "上传图片";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before{
	content: "正常";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before{
	content: "小";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before{
	content: "正常";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before{
	content: "大";
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{
	content: "超大";
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before, .ql-snow .ql-picker.ql-header .ql-picker-item::before{
	content: "正常";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before{
	content: "小";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before{
	content: "大";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{
	content: "超大";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before{
	content: "一号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before{
	content: "二号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before{
	content: "三号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before{
	content: "四号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before{
	content: "五号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before{
	content: "六号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before{
	content: "一号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before{
	content: "二号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before{
	content: "三号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before{
	content: "四号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before{
	content: "五号标题";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before{
	content: "六号标题";
}

</style>



// WEBPACK FOOTER //
// src/components/infoMana/editInfo.vue